import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  type ComparativeObjectResponse,
  type CreateComparativeObjectPayload,
  type ExportComparativeObjectPayload
} from '../models/comparative-object.model';

@Injectable({ providedIn: 'root' })
export class ComparativeObjectService {
  private readonly baseUrl = environment.baseUrl;

  constructor(private readonly http: HttpClient) {}

  generate(payload: CreateComparativeObjectPayload): Observable<ComparativeObjectResponse> {
    return this.http.post(
      `${this.baseUrl}/Comparative/Generate`,
      payload,
      { responseType: 'text' }
    ).pipe(
      map((responseText) => this.parseResponse(responseText))
    );
  }

  exportDocx(payload: ExportComparativeObjectPayload): Observable<HttpResponse<Blob>> {
    return this.http.post(
      `${this.baseUrl}/Comparative/ExportDocx`,
      payload,
      {
        observe: 'response',
        responseType: 'blob'
      }
    );
  }

  private parseResponse(responseText: string): ComparativeObjectResponse {
    const trimmedResponse = responseText.trim();

    if (!trimmedResponse) {
      throw new Error('Comparative API returned an empty response.');
    }

    return JSON.parse(trimmedResponse) as ComparativeObjectResponse;
  }
}
